<template>
  <!-- 使用：this.$msg('text') -->
  <div v-show="isShow" class="message">
    <span class="message-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: {
    text: {
      // 弹窗的文字信息
      type: String,
      default: '',
    },
    isShow: {
      // 整个遮罩和弹窗是否显示
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  width: 100%;
  transition: opacity 0.3s;
  position: fixed;
  top: 50%;
  right: 0;
  height: 3.2rem;
  z-index: 9999 !important;
  text-align: center;
  transform: translateY(-50%);
  &-text {
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 3.33333rem;
    padding: 0.8rem 1.66667rem;
    color: white;
    font-size: 1.06667rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message/message.vue